import { logCoreUsage } from 'owa-analytics';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { BizChatSidePaneSources } from 'owa-bizchat-types';
import type { MailboxInfo } from 'owa-client-types';
import {
    getBizChatWindowKey,
    getOrRegenerateSidePaneOpenToCloseSessionId,
    getTimeSinceSidepaneOpened,
    getSidePaneOpenToCloseSessionId,
} from 'owa-copilot-chat-drawer-store';
import isPopout from 'owa-popout-v2/lib/utils/isPopout';

/**
 * @param source The entry point source that triggered the BizChat Side Pane opening.
 * @param mailboxInfo The mailbox information of the user opening the BizChat Side Pane.
 * @param targetWindow The window where the BizChat Side Pane is being opened, used to determine if it's a popout and for telemetry correlation.
 * @param correlationId The correlation ID associated with the BizChat session, if applicable (e.g. for a prompt hand-in).
 * @param isFlexPaneAlreadyOpen Indicates whether the BizChat Side Pane is already open,
 *                              used to understand full usage for features that can populate the input box.
 * @param isNewChat Indicates whether this is opening a new chat or reusing an existing chat.
 */
export function logBizChatSidePaneEntrypoint(
    source: BizChatSidePaneSources,
    mailboxInfo: MailboxInfo,
    targetWindow: Window,
    correlationId?: string,
    isFlexPaneAlreadyOpen?: boolean,
    isNewChat?: boolean,
    skipSessionIdRegeneration?: boolean,
    isMcpComposeHandoff?: boolean
): void {
    if (isGlobalFeatureEnabled('mon-copilot-bizchat')) {
        const sessionIdToUse = skipSessionIdRegeneration
            ? getSidePaneOpenToCloseSessionId(targetWindow)
            : getOrRegenerateSidePaneOpenToCloseSessionId(targetWindow);
        logCoreUsage('OutlookCopilotChat_BizChatSidePaneEntrypoints', mailboxInfo, {
            source,
            isFlexPaneAlreadyOpen: isFlexPaneAlreadyOpen ?? false,
            isNewChat: isNewChat ?? false,
            isPopout: isPopout(targetWindow),
            windowKey: getBizChatWindowKey(targetWindow),
            sidePaneOpenToCloseSessionId: sessionIdToUse,
            timeSinceOpened: getTimeSinceSidepaneOpened(targetWindow),
            correlationId,
            ...(isMcpComposeHandoff === true ? { isMcpComposeHandoff } : {}),
        });
    }
}
